module.exports = __webpack_public_path__ + "assets/images/spritesheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/spritesheet.png
// module id = 106
// module chunks = 1